import { useEffect, useState } from "react";

import {
  getGeoCities,
  getGeoHeatmap,
  getGeoSummary,
} from "../api/traceabilityApi";

export function useGeoDistribution(filters) {
  const { product, granularity, from_date, to_date, province_code } = filters;
  const requestKey = JSON.stringify(filters);
  const [result, setResult] = useState({ key: null, data: null, error: null });

  useEffect(() => {
    let live = true;
    const query = {
      product,
      from_date: from_date || undefined,
      to_date: to_date || undefined,
    };
    Promise.all([
      getGeoSummary(query),
      getGeoHeatmap({ ...query, granularity }),
      getGeoCities({ ...query, province_code: province_code || undefined }),
    ])
      .then(([summary, heatmap, cities]) => {
        if (live) setResult({ key: requestKey, data: { summary, heatmap, cities }, error: null });
      })
      .catch((error) => {
        if (live) setResult({ key: requestKey, data: null, error });
      });
    return () => {
      live = false;
    };
  }, [product, granularity, from_date, to_date, province_code, requestKey]);

  const current = result.key === requestKey;
  return {
    data: current ? result.data : null,
    loading: !current,
    error: current ? result.error : null,
  };
}
